import React from "react"
import ReactDOM from "react-dom"
import SectionPageHeader from "./section-page-header-component"

export default class SectionPageHeaderModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<SectionPageHeader {...self.modelJson} />, self.elem)
  }
}
